module.exports = __webpack_public_path__ + "img/inallar-logo.abdfd8a3.svg";